import { httpRequest } from "../../http";
import type { CorrectionField } from "@models/Discrepancy.model";

export class CommandListCorrectionFields {
  async run(discrepancyId: number): Promise<CorrectionField[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/discrepancies/${discrepancyId}/fields/`;
    return httpRequest<CorrectionField[]>(url, { method: "GET" });
  }
}
